import { render, staticRenderFns } from "./phoUp.vue?vue&type=template&id=9b6eb23e&scoped=true"
import script from "./phoUp.vue?vue&type=script&lang=js"
export * from "./phoUp.vue?vue&type=script&lang=js"
import style0 from "./phoUp.vue?vue&type=style&index=0&id=9b6eb23e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6eb23e",
  null
  
)

export default component.exports